<template>
  <v-card class="dialog">
    <div class="header">
      <v-app-bar flat>
        <div class="gotoMaster d-flex align-end mb-3">
          <div class="title mr-5" style="white-space: pre-line">
            {{ getTitle }}
          </div>
          <v-spacer></v-spacer>
          <v-btn
            v-if="gotoMaster"
            color="primary"
            class="mx-5"
            @click="onClickGotoMaster"
            >マスタ登録画面へ</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn icon @click="$emit('close')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <template v-slot:extension>
          <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab v-for="(form, key) in SITES_FORMS" :key="key">
              {{ form.title }}
            </v-tab>
          </v-tabs>
        </template>
      </v-app-bar>
      <v-divider></v-divider>
    </div>
    <div v-if="isAdminOrPartner" class="px-5 pt-3">
      <SelectWithFilter
        name="main_contractor_id"
        :items="mainContractorList"
        :values="formValues"
        :editable="true"
        placeholder="元請を選択"
        @onInput="onInput"
      />
    </div>
    <!-- 検索コンポーネント -->
    <SearchSelectList
      :formValues="formValues"
      :top="120"
      @search="search"
      @formUpdate="formUpdate"
    >
      <v-list two-line>
        <div v-for="item in items" :key="item.field_id">
          <v-list-item ripple>
            <v-list-item-content @click="onClick(item.field_id)">
              <v-list-item-title class="field_name">{{
                item.name
              }}</v-list-item-title>
              <v-list-item-subtitle class="address">{{
                item.prefecture + " " + item.city + " " + item.address
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
      <div v-if="items.length == 0" style="text-align: center">
        {{ NO_DATA_MESSAGE }}
      </div>
    </SearchSelectList>
  </v-card>
</template>

<script>
import { Store } from "@/store/Store.js";
import { NO_DATA_MESSAGE, COMPANY_TYPE } from "@/constants/COMMON";
import { COMPANY_TYPE_MAIN_CONTRACTOR } from "@/constants/COMPANY";
import {
  HEADER_MENU_ITEMS_INHOUSE,
  SITES_FORMS,
} from "@/constants/GLOBALHEADER";

// Components
import SearchSelectList from "@/components/forms/elements/SearchSelectList";
import SelectWithFilter from "@/components/forms/elements/SelectWithFilter";

export default {
  components: {
    SearchSelectList,
    SelectWithFilter,
  },
  data() {
    return {
      NO_DATA_MESSAGE,
      COMPANY_TYPE_MAIN_CONTRACTOR,
      SITES_FORMS,
      tab: null,
      items: [],
      mainContractorList: [],
    };
  },
  props: {
    title: String,
    formValues: {
      type: Object,
      default: () => {
        return {
          // 検索ワード
          search: "",
          // 表示するリスト
          items: [],
          // 元請会社Id
          main_contractor_id: null,
          // 選択項目id
          selected: null,
        };
      },
    },
    onSearch: Function,
    close: Function,
    gotoMaster: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getTitle() {
      return this.isAdminOrPartner
        ? this.title
        : `${this.loginUser.company_name}\n${this.title}`;
    },
    loginUser() {
      return Store.state.Login.user;
    },
    companyType() {
      return this.loginUser?.company_type;
    },
    isAdminOrPartner() {
      if (
        this.companyType === COMPANY_TYPE.ADMIN ||
        this.companyType === COMPANY_TYPE.PARTNER
      ) {
        return true;
      } else {
        return false;
      }
    },
    isPartner() {
      if (this.companyType === COMPANY_TYPE.PARTNER) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.tab = 0;
    this.formValues.main_contractor_id = null;
    this.isPartner
      ? this.getListCompanyUsersField()
      : this.getMainContractorList();
    this.getListByTab(this.tab);
  },
  watch: {
    formValues: {
      handler(newVal) {
        this.items = newVal.items;
      },
      deep: true,
      immediate: true,
    },
    tab: {
      handler(newVal) {
        this.getListByTab(newVal);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async getMainContractorList() {
      let apiParams = { company_type: [COMPANY_TYPE_MAIN_CONTRACTOR] };
      const entries = await Store.dispatch(
        `Company/getMainContractor`,
        apiParams
      );
      if (!entries.hasError) {
        this.mainContractorList = [...entries];
        this.mainContractorList.unshift({ id: null, name: "" });
      }
    },
    async getListCompanyUsersField() {
      const result = await Store.dispatch(`Company/getListCompanyUsersField`);
      this.mainContractorList = [...result];
      this.mainContractorList.unshift({ id: null, name: "" });
    },
    getListByTab(val) {
      switch (val) {
        case 0:
          this.onInput({ name: "end_use_flg", value: null });
          break;
        case 1:
          this.onInput({ name: "end_use_flg", value: 1 });
          break;
        default:
          this.onInput({ name: "end_use_flg", value: null });
          break;
      }
    },
    // 検索(propsで渡すだけ)
    search() {
      this.$emit("onSearch");
    },

    onInput({ name, value }) {
      const formValues = { ...this.formValues };
      formValues[name] = value;
      this.formUpdate(formValues);
      this.search();
    },

    // formデータ更新(propsで渡すだけ)
    formUpdate(values) {
      this.$emit("formUpdate", values);
    },

    // idの更新
    onClick(id) {
      const values = { ...this.formValues };
      values.selected = id;
      this.$emit("formUpdate", values);
    },

    onClickGotoMaster() {
      this.$router
        .push(HEADER_MENU_ITEMS_INHOUSE.MACHINES.path)
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            console.error(err);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/themes.scss";

.dialog {
  .v-sheet {
    background-color: $background_color !important;
  }
  .header {
    position: sticky;
    top: 0;
    background-color: $background_color;
    z-index: 1;
    .header-title-area {
      display: flex;
      justify-content: space-between;
      min-width: 100%;
      max-width: 100%;
    }
  }
  .body {
    .text-wrap {
      padding: 16px 0;
      position: relative;
      .text {
        text-align: center;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        width: 80%;
      }
    }
  }
  .btn {
    margin-right: 12px;
  }
}
.gotoMaster {
  width: 100% !important;
}
.field_name {
  font-size: 18px !important;
  font-weight: bold !important;
}
.address {
  font-size: 12px !important;
}

::v-deep .v-toolbar__content {
  background-color: $background_color !important;
}
</style>
